import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/tretiranjeUcinkovina";

export const fetchActiveSubstancesPage = createAsyncThunk(
  "active-substance/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const activeSubstanceSlice = createSlice({
  name: "activeSubstance",
  initialState: {
    page: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveSubstancesPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchActiveSubstancesPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchActiveSubstancesPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default activeSubstanceSlice.reducer;
